import './App.css';
import "antd/dist/antd.css";
import './i18nextConf';
import 'react-user-guide/dist/custom-style.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import React, { Component, Suspense } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { SpinnerLoad } from './component/atom/spinner';
import { BackTop } from 'antd';


// containers 
const TheLayout = React.lazy(() => import('./containers/templates/light-mode/layout'));

const Log = React.lazy(() => import('./containers/page/log'));

// pages 
const Login = React.lazy(() => import('./containers/page/login'))
const Andone1 = React.lazy(() => import('./containers/page/andon/andon1'))
const GrapheneMachine = React.lazy(() => import('./containers/page/andon/graphene-machine'))
const Utils = React.lazy(() => import('./containers/page/utils'))
const AndonOilStation = React.lazy(() => import('./containers/page/andon/oil-station'))

class App extends Component {

  render() {
    return (
      <>
        <HashRouter>
          <Suspense fallback={<SpinnerLoad />}>
            <Switch>
              <Route exact path="/log" name="log" render={props => <Log {...props} />} />
              <Route exact path="/login" name="Login" render={props => <Login {...props} />} />
              <Route exact path="/Utils" name="Utils" render={props => <Utils {...props} />} />
              <Route exact path="/andon-station" name="AndonOilStation" render={props => <AndonOilStation {...props} />} />
              <Route exact path="/graphine" name="AndonOilStation" render={props => <GrapheneMachine {...props} />} />
              <Route path="/" name="Home" render={props => <TheLayout {...props} />} />
            </Switch>
          </Suspense>
        </HashRouter>
    <BackTop style={{background:'blue', borderRadius: '50%'}}/>
      </>
    )
  }
}

export default App;
